import { ROUTE_SIGN_IN_ENTER_EMAIL } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './enter-email.page';

export const routeEnterEmail: RouteObject = {
  path: ROUTE_SIGN_IN_ENTER_EMAIL,
  Component: Page,
  loader: setTitleFromLoader('Sign In'),
};
